import Vue from 'vue';
import CartProductQuantity from '@/modules/product/components/ProductQuantity.vue';
import { mapActions, mapState } from 'vuex';
import { SelectionType } from '@/modules/product/model/ProductDto';
import VariantSelectedPreview from '@/modules/product/components/VariantSelectedPreview.vue';
export default Vue.extend({
    components: {
        CartProductQuantity,
        VariantSelectedPreview,
    },
    props: {
        item: Object,
        toast: Boolean,
    },
    data() {
        return {
            SelectionType: SelectionType,
            disableQuantityButton: false,
        };
    },
    computed: {
        ...mapState('cartModule', ['cartMessages']),
    },
    methods: {
        ...mapActions('cartModule', ['updateItemQuantity', 'removeItem']),
        cartRemoveItem() {
            this.removeItem(this.item).then(() => {
                if (this.cartMessages) {
                    this.$bvToast.toast(this.cartMessages.join(', '), {
                        variant: 'info',
                    });
                }
            });
        },
        onQuantitySelected(cartItem, newQuantity) {
            this.disableQuantityButton = true;
            this.updateItemQuantity({ ...cartItem, quantity: newQuantity })
                .then(() => {
                if (this.cartMessages) {
                    this.$bvToast.toast(this.cartMessages.join(', '), {
                        variant: 'info',
                    });
                }
            })
                .catch((error) => {
                console.log(error);
                this.$bvToast.toast(error.data.message, { variant: 'danger' });
            })
                .finally(() => {
                setTimeout(() => {
                    this.disableQuantityButton = false;
                }, 100);
            });
        },
    },
    created() {
    },
});
